import * as React from 'react';
import {connect} from 'react-redux';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as MapModule from 'Modules/MapModule';
import * as AlertModule from 'Modules/AlertModule';
import * as HistoryModule from 'Modules/HistoryModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as FleetModule from 'Modules/FleetModule';
import 'react-table/react-table.css';
import {CustomSort, CarStatusAndCategoryFiltering, CarFleetFiltering, FleetCell} from './CustomFilterComponents';
import {createSerachQuery} from 'Connectors/_main';
import * as Dictionary from 'Models/Dictionary';
import {injectThProps, checkPageQuery, Filter} from 'HelperFunctions/Lists';
import {withTranslation} from 'react-i18next';
import {InfinityReactTable, InfinityScrollParams} from "components/common/InfinityReactTable";
import {Filter as RTFilter, TableProps} from 'react-table'
import {Types} from "Modules/VehiclesModule";
import PaginatedListCarDto = Types.PaginatedListCarDto;
import {EnumTypes as PageEnumTypes} from "Modules/ViewManagementModule";
import {DEFAULT_PAGE_SIZE} from "../../../constants";

import {IGetCarsParams} from "Models/VehicleModel";
import axios, {CancelToken, CancelTokenSource} from "axios";
import {RouterState} from "react-router-redux";

type State = {
    activeSorting: string;
    activeFilter: string;
    page: number;
    vehiclesPartList: Array<VehiclesModule.Types.CarDto>;
};
type Props = {
    match?: any;
    tableOnly?: boolean;
};

type ConnectedProps = {
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    fleetStore: FleetModule.Types.FleetStore;
    alertStore: AlertModule.Types.AlertStore;
    t?: (key: string) => string;
    location?: RouterState['location']
};
type DispatchedProps = {
    getFilteredCars: (params: URLSearchParams, noloader?: boolean) => void;
    setVehiclesPartList: (partList: Array<VehiclesModule.Types.CarDto>) => void;
    setFilterVehiclesBase: (partList: VehiclesModule.Types.PaginatedListCarDto) => void;
    setMapCenter: (center: MapModule.Types.MapCenter, zoom: number) => void;
    setMapZoom: (zoom: number) => void;
    setVehicleDetailsPage: (vehicle: VehiclesModule.Types.CarDto) => void;
    getSingleCarDetails: (carId: number) => void;
    setActiveRideViewType: (activeRideViewType: HistoryModule.EnumTypes.RideViewType) => void;
    getTodaysCarRides: (carId: number) => void;
    // showDetailsPage: Function;
    manageFleetCars: (type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto) => void;
    showVehicleList: Function;
    hideVehicleList: Function;
    updateFleet: (fleetId: number, fleetData: FleetModule.Types.AddFleetRequest) => void;
    manageAlertCars: (type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto) => void;
    getUsersFleet: () => void;
    resetCarFilteredData: () => void;
    search: (query: string) => Promise<void>;
    onFilteredSearchedChange: TableProps['onFilteredChange']
    onFilteredChange: (newFiltering: RTFilter[], column: any, value: any, cancelToken: CancelToken) => void
    resetSucceed: () => void
    clearHistoryRides: () => void
    clearHistoryRidesSubmission: () => void
    getCars: (params: IGetCarsParams, cancelToken: CancelToken) => Promise<void>
};

class VehicleList extends React.Component<Props & ConnectedProps & DispatchedProps, State> {
    private initialLoad: boolean;
    private innerWidth: number;
    private vehiclesPartListOptions: {
        currentPage: number,
        amountPerLoad: number
    };
    private cancelTokenSource: CancelTokenSource
    constructor(props: Props & ConnectedProps & DispatchedProps) {
        super(props);
        this.state = {
            activeSorting: '',
            activeFilter: '',
            page: 0,
            vehiclesPartList: []
        };

        this.initVehiclesListOptions();

        this.getFilteredData = this.getFilteredData.bind(this);
        this.getVehiclesPartList = this.getVehiclesPartList.bind(this);
        this.getVehiclesNextPart = this.getVehiclesNextPart.bind(this);
        this.fetchMoreSearchedVehicles = this.fetchMoreSearchedVehicles.bind(this);
        this.fetchMore = this.fetchMore.bind(this);
        this.setActiveSorting = this.setActiveSorting.bind(this);
        this.handleFilter = this.handleFilter.bind(this);

        this.infinityScrollParams = new InfinityScrollParams();
        this.infinityScrollParams.setWaypointRef(React.createRef());
    }

    private initVehiclesListOptions() {
        this.vehiclesPartListOptions = {
            currentPage: 0,
            amountPerLoad: 10
        };
    }

    public modelFilterInputRef = React.createRef<HTMLInputElement>()
    public vinFilterInputRef = React.createRef<HTMLInputElement>()
    public licensePlateFilterInputRef = React.createRef<HTMLInputElement>()
    public categoryAndStatusFilterRef = React.createRef<CarStatusAndCategoryFiltering>()

    private categoryAndStatusFilter = ({column, filter, onChange}) => <CarStatusAndCategoryFiltering
        ref={this.categoryAndStatusFilterRef}
        isActive={this.state.activeFilter === column.id}
        value={filter ? filter.value : ''}
        toggleOpen={() => this.setState({activeFilter: this.state.activeFilter === column.id ? '' : column.id})}
        onChange={e => {
          onChange(e)
        }}
    />;

    private licensePlateFilterOld = Filter.InputTextFilterWithRef.bind(this, this.licensePlateFilterInputRef, this.props.t('licensePlate'), false);
    private vinFilter = Filter.InputTextFilterWithRef.bind(this, this.vinFilterInputRef, this.props.t('vin'), false);
    // TODO: dorobić fixa do sortowania na froncie
    private vehicleSpeedSorting = Filter.speedSorting.bind(this, this.props.t('speedGps'));
    private modelFilter = Filter.InputTextFilterWithRef.bind(this, this.modelFilterInputRef, this.props.t('model'), false);

    private setActiveSorting(e: any, colId: string, onChange: Function) {
        this.setState({
                activeSorting: colId
            }, () => onChange(e)
        );
    }

    private licensePlateFilter = Filter.CustomInputTextFilter.bind(this, this.props.t('licensePlate'), typedValue => {
        const baseList: VehiclesModule.Types.PaginatedListCarDto = {
            results: [],
            totalCount: 0,
            first: 0,
            max: 0
        };
        if (typeof typedValue === 'string') {
            // jeśli wpisuję coś w filtr to 'resetuję' całą listę włącznie ze wskaźnikami na dany part.
            this.initVehiclesListOptions();
            // i jako bazową listę, która później będzie paginowana przyjmuję wyfiltrowany wycinek Store'a
            baseList.results = this.props.vehiclesStore.vehiclesList.filter(item => {
                try {
                    return item.licensePlate.includes(typedValue);
                } catch (e) {
                    return false;
                }
            });

            baseList.totalCount = baseList.results.length

            this.props.setFilterVehiclesBase(baseList);
        }
        // this.getVehiclesPartList(null, true); //przywrócić jeśli wróci infinityScrollTable
    });
    private infinityScrollParams: InfinityScrollParams;
    private allowBackWaypoint = false;

    public componentWillUnmount() {
        this.initialLoad = false;
        this.cancelTokenSource.cancel()
        this.cancelTokenSource = undefined
    }

    public async componentDidMount() {
        this.innerWidth = window.innerWidth;
        this.cancelTokenSource = axios.CancelToken.source()
        // await this.props.getFilteredCars(null, false); //przepisać do _Map -> jest tam odpowiednie todo.
        // this.getVehiclesPartList(null); //przywrócić jak wejdzie BACKwaypoint

        const searchParams = new URLSearchParams(this.props.location?.search ?? '')
        const carId = searchParams?.get('search-car-id')
        if (carId && this.props.vehiclesStore.searchedVehicles.results.length > 0) {
          const foundCar = this.props.vehiclesStore.searchedVehicles.results.find((car) => car.id.toString() === carId.toString())
          this.vehicleClick(foundCar)
        }
    }
    public componentDidUpdate(prevProps) {
      if (this.props.vehiclesStore.shouldResetFilters) {
        this.modelFilterInputRef.current.value = ''
        this.vinFilterInputRef.current.value = ''
        this.licensePlateFilterInputRef.current.value = ''
        this.categoryAndStatusFilterRef.current.resetValues()

        this.setState({ activeFilter: '' })

        this.props.resetSucceed()
      }
      if (prevProps.match && prevProps.match?.path !== this.props.match?.path) {
        this.modelFilter = Filter.InputTextFilterWithRef.bind(this,  this.modelFilterInputRef, this.props.t('model'), false);
        this.licensePlateFilterOld = Filter.InputTextFilterWithRef.bind(this, this.licensePlateFilterInputRef, this.props.t('licensePlate'), false);
        this.vinFilter = Filter.InputTextFilterWithRef.bind(this, this.vinFilterInputRef, this.props.t('vin'), false);

        // Logika do innej części apki, ale if spasował to nie tworzyłem nowego
        this.cancelTokenSource.cancel()
        this.cancelTokenSource = axios.CancelToken.source()
      }
    }

  private async getAllData(state) {
        if (this.props.fleetStore.fleets === null) {
            await this.props.getUsersFleet();
        }
        if (this.props.vehiclesStore.vehiclesList.length === 0) {
            await this.props.getFilteredCars(null);
        }

        if (state.filtered.length) {
            const query = checkPageQuery(state.filtered, state.page);
            this.getFilteredData(query);
        } else {
            this.props.resetCarFilteredData();
        }

    }

    private async getFilteredData(filters: Array<{ id: any; value: any }>) {
        const params = createSerachQuery(filters);
        await this.props.getFilteredCars(params);
    }

    public async vehicleClick(vehicle: VehiclesModule.Types.CarDto) {
        const {activeVehicleDetails} = this.props.vehiclesStore;
        const {setMapCenter, setMapZoom, match, manageFleetCars, fleetStore, manageAlertCars} = this.props;
        if (match.path === '/fleet/add') {
            manageFleetCars('ADD', vehicle);
        } else if (match.params.fleetId) {
            const checkIfContains = fleetStore.manageFleetCarsIds.findIndex(e => e === vehicle.id);
            if (checkIfContains === -1) {
                manageFleetCars('ADD', vehicle);
            }
        } else if (match.params.alertId) {
            manageAlertCars('ADD', vehicle);
        } else if (match.path === Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.CARRAPORT)) {
            this.props.setVehicleDetailsPage(vehicle);
        } else {
            if (vehicle.latestDataframe) {
                await setMapCenter({lat: vehicle.latestDataframe.latitude, lng: vehicle.latestDataframe.longitude}, 16);
            }
            if (!activeVehicleDetails || activeVehicleDetails.id !== vehicle.id) {
                this.props.clearHistoryRides()
                this.props.clearHistoryRidesSubmission()
                this.props.setVehicleDetailsPage(vehicle);
                await this.props.getSingleCarDetails(vehicle.id);
                await this.props.setActiveRideViewType(HistoryModule.EnumTypes.RideViewType.TODAYS);
                await this.props.getTodaysCarRides(vehicle.id);
                // this.props.showDetailsPage();
            }
        }
    }

    private getVehiclesPartList(state, direction = true) {
        // Jeśli nie filtrujemy to operujemy na całej liście.
        // Dzięki temu ciągle trzymamy w Store wszystkie pojazdy, a w tabeli możemy żonglować wybranymi.
        const baseList = this.props.vehiclesStore.vehiclesListFiltered.results;

        const pageAdd = direction ? 1 : -1;

        const page = this.vehiclesPartListOptions.currentPage + pageAdd;
        const amountPerLoad = this.vehiclesPartListOptions.amountPerLoad;
        const first = (page - 1) * amountPerLoad / 2;
        let currentAmount;

        // if(first + 2*amountPerLoad - baseList.length > 0) {
        //     currentAmount = baseList.length;
        // } else {
        currentAmount = first + amountPerLoad;
        this.vehiclesPartListOptions.currentPage = page;
        try {
            const tableBody = document.querySelector('.vehicleList--expanded');
            tableBody.scrollTop = tableBody.scrollTop - pageAdd * (amountPerLoad / 2) * 40;   // 40 -> wysokość jednego wiersza
            this.allowBackWaypoint = page > 1 ? true : false;
            // console.log(tableBody.scrollTop);
        } catch (e) {
            // console.log(e);
        }
        // }
        // console.log('TEST VEHICLES LOAD', page, currentAmount, pageAdd);
        this.props.setVehiclesPartList(baseList.slice(first, currentAmount));
    }

    private getVehiclesNextPart(tableState) {
        const {vehiclesList, vehiclesListFiltered} = this.props.vehiclesStore;
        const filters = tableState !== null ? tableState.filtered : null;
        let baseList;

        if (filters && filters.length) { // podczas używania filtru

            // muszę najpierw przetransformować filrty "łączone" do postaci znormalizowanej (np. carCategory&carStatus)

            // 1. łączone filtry mają w nazwie '&' więc je sobie wyciągam
            const connectedFilters = filters.filter(filter => filter.id.includes('&'));
            // 2. dla każdego składnika tworzę płastszą strukturę (mogę się bawić w optymalizacje tych pętli, ale w zasadzie we wszystkich przypadkach będą to proste dwu-elementowe iteracje)
            const separatedFilters = [];
            connectedFilters.forEach(filter => {
                const ids = filter.id.split('&');
                ids.forEach(id => {
                    separatedFilters.push({
                        id,
                        value: filter.value[id]
                    });
                });
            });
            // 3. wywalam z filtrów "łączony" obiekt
            let newFilters = filters.filter(filter => !filter.id.includes('&'));
            // 4. i dodaję odseparowane filtry
            newFilters = [...separatedFilters, ...newFilters];

            // filtrując określam zbiór na podstawie oryginalnej-całej tablicy pojazdów
            baseList = vehiclesList.filter(item => !newFilters.some(filter => {
                if (typeof filter.value === 'string') {
                    return -1 * item[filter.id]?.toLowerCase().indexOf((filter.value)?.toLowerCase())
                }
                return filter.value?.length && !filter.value.includes(item[filter.id])
            }));

            // zapisuję go w zafiltrowanych
            const filteredCars: PaginatedListCarDto = {
                first: 0,
                max: 1000,
                results: baseList,
                totalCount: baseList.length
            };
            this.props.setFilterVehiclesBase(filteredCars);
            this.vehiclesPartListOptions.currentPage = 0;
            try {
                document.querySelector('.table__content--expanded').scrollTop = 0
            } catch (e) {
                // console.log(e);
            }
        } else if (filters && filters.length === 0) {
            // doładowanie filtrowe z pustymi filtrami -> oryginalna cała
            baseList = vehiclesList;
            // w store filteredList też resetuję do stanu przed filtrowaniem
            this.props.setFilterVehiclesBase({
                first: 0,
                max: 1000,
                results: baseList,
                totalCount: baseList.length
            });

            try {
                document.querySelector('.table__content--expanded').scrollTop = 0
            } catch (e) {
                // console.log(e);
            }
        } else {
            // w innym przypadku biorę zafiltrowaną -> bez filtrów jest cała, PO użyciu filtrów jest zafiltorwana
            baseList = vehiclesListFiltered.results;
        }

        const page = this.vehiclesPartListOptions.currentPage;
        const amountPerLoad = this.vehiclesPartListOptions.amountPerLoad;

        if (page * amountPerLoad <= baseList.length) {
            this.props.setVehiclesPartList(baseList.slice(0, (page + 1) * amountPerLoad));
            this.vehiclesPartListOptions.currentPage++;
        }
    }

    // Na razie zostawiam bo nie wiem czy wszystko git przepięte
    private renderInfinityReactTable() {
        const {activeVehicleDetails, vehiclesPartList, vehiclesList} = this.props.vehiclesStore;
        const {manageFleetCarsIds} = this.props.fleetStore;
        const {manageCarsIds} = this.props.alertStore;
        const {match} = this.props;

        return <InfinityReactTable
          addClass="reactTable vehicleList--table fixed-header"
          data={vehiclesPartList}
          dataLength={vehiclesList.length}
          loadingText={'Ładowanie...'}
          pageText={'Strona'}
          nextText={'Następna'}
          previousText={'Poprzednia'}
          getTheadThProps={injectThProps}
          rowsText={'wierszy'}
          noDataText={'Brak danych do wyświetlenia'}
          getTrProps={(state: any, rowInfo: any) => {
              let className: string = '';
              if (rowInfo && rowInfo.original) {
                  if (match.path === '/fleet/add' || match.params.fleetId) {
                      className = rowInfo.original.id ? (manageFleetCarsIds.includes(rowInfo.original.id) ? 'active' : '') : '';
                  } else if (match.path === '/alerts/add' || match.params.alertId) {
                      className = rowInfo.original.id ? (manageCarsIds.includes(rowInfo.original.id) ? 'active' : '') : '';
                  } else if (match.path === Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.CARRAPORT) && activeVehicleDetails) {
                      className = rowInfo.original.id === activeVehicleDetails.id ? 'active' : '';
                  } else if (activeVehicleDetails) {
                      className = rowInfo.original.id === activeVehicleDetails.id ? 'active' : '';
                  }
              }

              return {
                  onClick: () => {
                      this.vehicleClick(rowInfo.original);
                  },
                  className
              };
          }}

          // pageSize={this.vehiclesPartListOptions.amountPerLoad} //wykorzystane to BACKwaypointa
          // onFetchData={this.getVehiclesPartList} //z BACKwaypointem
          pageSize={10}
          onFetchData={this.getVehiclesNextPart}
          columns={this.getColumns}
          manual={true}
          waypointRef={this.infinityScrollParams.getWaypointRef()}
          allowBackWaypoint={this.allowBackWaypoint}
          data-testid="vehicles-table"
        />;
    }

    private get getColumns() {
        const {t} = this.props;

        return [
            {
                Header: 'hiddenHeader',
                id: 'carCategory&speedLimitExceedance',
                accessor: 'latestDataframe.speedLimitExceedance',
                className: 'cell cell--higher cell__car-status',
                width: this.innerWidth > 991 ? 90 : 70,
                Filter: this.categoryAndStatusFilter,
                Cell: ({value}) => (
                  <>
                      <img src={Dictionary.CarStatusTableFilters.get(value)} height={25} alt=""/>
                  </>
                )
            },
            {
                Header: 'hiddenHeader',
                id: 'licensePlate',
                className: 'cell cell--higher',
                accessor: 'licensePlate',
                width: this.innerWidth > 991 ? 250 : 70,
                Filter: this.licensePlateFilterOld
            },
            {
                Header: 'hiddenHeader',
                id: 'vin',
                className: 'cell cell--higher',
                accessor: 'vin',
                width: this.innerWidth > 991 ? 200 : 140,
                Filter: this.vinFilter
            },
            {
                Header: 'hiddenHeader',
                id: 'model',
                className: 'cell cell--higher',
                accessor: 'model',
                width: 90,
                Filter: this.modelFilter
            },
            {
                Header: 'hiddenHeader',
                id: 'vehicleSpeed',
                className: 'cell cell--higher',
                accessor: 'latestDataframe.speedGps',
                Cell: ({value}) => <>{value !== undefined ? `${value} km/h` : ''}</>,
                width: this.innerWidth > 991 ? 80 : 65,
                Filter: () => <div className="filter__title">{t('Prędkość')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'name',
                className: 'cell cell--higher',
                accessor: 'name',
                width: 90,
                Filter: () => <div className="filter__title">{t('name')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'fleet_id',
                accessor: 'fleets',
                className: 'cell cell--higher fleet__cell',
                Cell: cellInfo => <FleetCell cellInfo={cellInfo} />,
                Filter: () => <div className="filter__title">{t('Flota')}</div>
            }
        ];
    }

    private async fetchMoreSearchedVehicles(tableState, scrolled, loadedCount) {
      const {
        queryParams,
        vehiclesListFiltered
      } = this.props.vehiclesStore

      const first = scrolled ? Number(queryParams.get('first')) + DEFAULT_PAGE_SIZE :  Number(queryParams.get('first'))

      if (vehiclesListFiltered.totalCount !== null && vehiclesListFiltered.totalCount <= first) {
        return
      }

      await this.props.search(queryParams.get('search'))
    }

    private async fetchMoreVehicles(tableState, scrolled, loadedCount) {
      const { basicQueryParams, vehiclesListFiltered } = this.props.vehiclesStore
      // Różni się obsługa od dociągania w search, gdyż nie zmieniałem poprzedniej wersji

      const first = scrolled ? basicQueryParams.first + DEFAULT_PAGE_SIZE : basicQueryParams.first

      if (this.modelFilterInputRef.current.value) {
        basicQueryParams.model = this.modelFilterInputRef.current.value
      }
      if (this.vinFilterInputRef.current.value) {
        basicQueryParams.vin = this.vinFilterInputRef.current.value
      }
      if (this.licensePlateFilterInputRef.current.value) {
        basicQueryParams.license_plate = this.licensePlateFilterInputRef.current.value
      }

      if (vehiclesListFiltered.totalCount !== null && vehiclesListFiltered.totalCount <= first) {
        return
      }

      this.props.getCars({
        ...basicQueryParams,
        first
      },
        this.cancelTokenSource.token
      )
    }

    private fetchMore(tableState, scrolled, loadedCount) {
      if (!scrolled) {
        return
      }

      // Boż kto to tak nawymyślał, by tak utrudnić sobie??? zostawiam sprawdzanie ścieżek, ale to po prostu powinno
      // być od zera inaczej zrobione.
      switch (this.props.match?.path) {
        case Dictionary.PageUrl.get(PageEnumTypes.Page.MAP): {
          this.fetchMoreSearchedVehicles(tableState, scrolled, loadedCount)
          break
        }
        default: {
          this.fetchMoreVehicles(tableState, scrolled, loadedCount)
        }
      }
    }

    private handleFilter(newFiltering: RTFilter[], column: any, value: any) {
      // Boż kto to tak nawymyślał, by tak utrudnić sobie??? zostawiam sprawdzanie ścieżek, ale to po prostu powinno
      // być od zera inaczej zrobione.
      switch (this.props.match?.path) {
        case Dictionary.PageUrl.get(PageEnumTypes.Page.MAP): {
          this.props.onFilteredSearchedChange(newFiltering, column, value)
          break
        }
        default: {
          this.props.onFilteredChange(newFiltering, column, value, this.cancelTokenSource.token)
        }
      }
    }

    private renderTable() {
        const {
          activeVehicleDetails,
          vehiclesListFiltered,
          tableSearchFilters
        } = this.props.vehiclesStore;
        const {manageFleetCarsIds} = this.props.fleetStore;
        const {manageCarsIds} = this.props.alertStore;
        const {match} = this.props;

        // konwersja do number po to by null ze stanu początkowego nie wywrócił rowerka z tabelką
        const pageSize = Number(vehiclesListFiltered.results.length < vehiclesListFiltered.max
          ? vehiclesListFiltered.results.length
          : vehiclesListFiltered.max)

        return <InfinityReactTable
          defaultFiltered={match?.path === Dictionary.PageUrl.get(PageEnumTypes.Page.MAP) ? tableSearchFilters : undefined}
          addClass="vehicle-list__search-table"
          data={vehiclesListFiltered.results}
          dataLength={vehiclesListFiltered.totalCount}
          pageSize={pageSize}
          loadingText={'Ładowanie...'}
          pageText={'Strona'}
          nextText={'Następna'}
          previousText={'Poprzednia'}
          getTheadThProps={injectThProps}
          rowsText={'wierszy'}
          noDataText={'Brak danych do wyświetlenia'}
          getTrProps={(state: any, rowInfo: any) => {
              let className: string = '';
              if (rowInfo && rowInfo.original) {
                  if (match.path === '/fleet/add' || match.params.fleetId) {
                      className = rowInfo.original.id ? (manageFleetCarsIds.includes(rowInfo.original.id) ? 'active' : '') : '';
                  } else if (match.path === '/alerts/add' || match.params.alertId) {
                      className = rowInfo.original.id ? (manageCarsIds.includes(rowInfo.original.id) ? 'active' : '') : '';
                  } else if (match.path === Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.CARRAPORT) && activeVehicleDetails) {
                      className = rowInfo.original.id === activeVehicleDetails.id ? 'active' : '';
                  } else if (activeVehicleDetails) {
                      className = rowInfo.original.id === activeVehicleDetails.id ? 'active' : '';
                  }
              }
              return {
                  onClick: () => {
                      this.vehicleClick(rowInfo.original);
                  },
                  className
              };
          }}
          columns={this.getColumns}
          onFetchData={this.fetchMore}
          manual={true}
          waypointRef={this.infinityScrollParams.getWaypointRef()}
          allowBackWaypoint={this.allowBackWaypoint}
          data-testid="vehicles-table"
          onFilteredChange={this.handleFilter}
        />;
    }

    public render() {
        const {vehicleListVisible} = this.props.viewManagementStore;

        if (!this.props.tableOnly) {
            return (
                <div className="table__bottom">
                    <div
                        className={`table-toggle ${vehicleListVisible ? 'table-toggle--open' : ''}`}
                        data-testid="vehicles-list-table-toggle"
                        onClick={() => {
                            if (vehicleListVisible) {
                                this.initialLoad = false;
                                this.props.hideVehicleList();
                            } else {
                                this.initialLoad = true;
                                this.props.showVehicleList();
                            }
                        }}
                    >
                        <div
                            className={`cell__expander cell__expander--white ${vehicleListVisible ? 'cell__expander--expanded' : ''}`}/>
                    </div>
                    <div
                        className={`table__content ${vehicleListVisible ? 'table__content--expanded' : 'table__content--hidden'}`}
                        ref={this.infinityScrollParams.getWaypointRef()} data-testid="vehicles-list-table-content">
                        {vehicleListVisible && this.renderTable()}
                    </div>
                </div>
            );
        } else {
            return <>{this.renderTable()}</>;
        }
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        vehiclesStore: state.vehiclesStore,
        viewManagementStore: state.viewManagementStore,
        fleetStore: state.fleetStore,
        alertStore: state.alertStore,
        location: state.router?.location
    };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        getCars: (params, cancelToken) => dispatch(VehiclesModule.Actions.getCars(params, cancelToken)),
        getFilteredCars: (params: URLSearchParams, noloader?: boolean) => dispatch(VehiclesModule.Actions.getCarsFiltered(params, noloader)),
        setVehiclesPartList: (partList: Array<VehiclesModule.Types.CarDto>) => dispatch(VehiclesModule.Actions.getPartOfVehicles(partList)),
        setFilterVehiclesBase: (partList: VehiclesModule.Types.PaginatedListCarDto) => dispatch(VehiclesModule.Actions.getCarsFilteredSuccess(partList)),
        setMapCenter: (center: MapModule.Types.MapCenter, zoom: number) => dispatch(MapModule.Actions.setMapCenter(center, zoom)),
        setMapZoom: (zoom: number) => dispatch(MapModule.Actions.setMapZoom(zoom)),
        setVehicleDetailsPage: (vehicle: VehiclesModule.Types.CarDto) => dispatch(VehiclesModule.Actions.setDetailsForVehile(vehicle)),
        getSingleCarDetails: (carId: number) => dispatch(VehiclesModule.Actions.getSingleCarDetails(carId, true)),
        setActiveRideViewType: (activeRideViewType: HistoryModule.EnumTypes.RideViewType) => dispatch(ViewManagementModule.Actions.SetActiveRideViewType(activeRideViewType)),
        getTodaysCarRides: (carId: number) => dispatch(HistoryModule.Actions.getTodaysCarRide(carId)),
        // showDetailsPage: () => dispatch(ViewManagementModule.Actions.showDetailsPanel()),
        manageFleetCars: (type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto) => dispatch(FleetModule.Actions.manageFleetCars(type, car)),
        manageAlertCars: (type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto) => dispatch(AlertModule.Actions.manageCars(type, car)),
        showVehicleList: () => dispatch(ViewManagementModule.Actions.showVehicleList()),
        hideVehicleList: () => dispatch(ViewManagementModule.Actions.hideVehicleList()),
        updateFleet: (fleetId: number, fleetData: FleetModule.Types.AddFleetRequest) => dispatch(FleetModule.Actions.updateFleet(fleetId, fleetData)),
        getUsersFleet: () => dispatch(FleetModule.Actions.getUsersFleet()),
        resetCarFilteredData: () => dispatch(VehiclesModule.Actions.resetCarFilteredData()),
        search: (query) => dispatch(VehiclesModule.Actions.search(query)),
        onFilteredSearchedChange: (newFiltering: RTFilter[], column: any, value: any) => dispatch(VehiclesModule.Actions.filterSearchedVehicles(newFiltering, column, value)),
        onFilteredChange: (newFiltering: RTFilter[], column: any, value: any, cancelToken: CancelToken) => dispatch(VehiclesModule.Actions.filterVehicles(newFiltering, column, value, cancelToken)),
        resetSucceed: () => dispatch(VehiclesModule.Actions.resetSucceed()),
        clearHistoryRides: () => dispatch(HistoryModule.Actions.clearHistoryRides()),
        clearHistoryRidesSubmission: () => dispatch(HistoryModule.Actions.clearHistoryRidesSubmission())
    };
}

export default withTranslation('carDetails')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(VehicleList) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Map/VehiclesList/VehiclesList.tsx